import React, { useState, useEffect } from 'react';
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const ViewPatientHistory = () => {
    const { id } = useParams();
    const [patient, setPatient] = useState(null);
    const [history, setHistory] = useState([]);

    useEffect(() => {
        // Simula la obtención de datos del paciente
        const dummyPatient = {
            id: 1,
            name: 'Vallery',
        };
        setPatient(dummyPatient);

        // Simula la obtención de historias clínicas del paciente
        const dummyHistory = [
            { date: '2024-12-01', diagnosis: 'Gastritis', treatment: 'Omeprazol 20mg', doctor: 'Dr. Carlos Espinoza' },
            { date: '2024-11-15', diagnosis: 'Resfriado común', treatment: 'Paracetamol 500mg', doctor: 'Dr. Juan García' },
        ];
        setHistory(dummyHistory);
    }, [id]);

    return (
        <Box className="center-align">
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2, width: '100%', maxWidth: '1200px' }}>
                {patient && (
                    <>
                        <Typography variant="h4" gutterBottom>Historia Clínica de {patient.name}</Typography>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Diagnóstico</TableCell>
                                        <TableCell>Tratamiento</TableCell>
                                        <TableCell>Médico Responsable</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {history.map((entry, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{entry.date}</TableCell>
                                            <TableCell>{entry.diagnosis}</TableCell>
                                            <TableCell>{entry.treatment}</TableCell>
                                            <TableCell>{entry.doctor}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default ViewPatientHistory;
